// @flow
import type { State } from 'store/State';
import { createSelector } from 'reselect';

import { getLocaleCode } from 'store/reducers/dealerLocale/selectors';

type CheckIn = {
  reservationId?: number,
  personId: number,
  isNavigating: boolean,
  signatureImg?: string,
  appointmentNotes: string,
  selfCheckinMileage: number,
  customerMobileNumber?: number,
  selfCheckinWaitState: string,
  statusTrackerURL?: string,
  selfCheckInStatus?: string,
  selfCheckinSigned: string,
  tellUsMoreSvcId: number,
  hasAdditionalServices: boolean,
  licensePlate: string,
  vehicleColor: string
};

type ConfigFlow = {
  additionalServices: '',
  additionalServicesNotes: '',
  selfCheckInFlow: string
};

type SelfCheckIn = {
  checkIn: CheckIn,
  configFlow: ConfigFlow
};

export const getSelfCheckInData = (state: State): SelfCheckIn =>
  state.selfCheckIn;

const getCheckInData = createSelector(
  getSelfCheckInData,
  ({ checkIn }) => checkIn
);

const getSelfCheckInConfigData = createSelector(
  getSelfCheckInData,
  ({ configFlow }) => configFlow
);

export const getSignature = createSelector(
  getCheckInData,
  ({ signatureImg }) => signatureImg
);

export const getAppointmentNotes = createSelector(
  getCheckInData,
  ({ appointmentNotes }) => appointmentNotes
);

export const getSelfCheckinMileage = createSelector(
  getCheckInData,
  ({ selfCheckinMileage }) => selfCheckinMileage
);

export const getSelfCheckInLicenseNumber = createSelector(
  getCheckInData,
  ({ licensePlate }) => licensePlate
);

export const getSelfCheckInCarColor = createSelector(
  getCheckInData,
  ({ vehicleColor }) => vehicleColor
);

export const getCustomerMobileNumber = createSelector(
  getCheckInData,
  ({ customerMobileNumber }) => customerMobileNumber
);

export const getSelfCheckinWaitState = createSelector(
  getCheckInData,
  ({ selfCheckinWaitState }) => selfCheckinWaitState
);

export const getSelfCheckInStatus = createSelector(
  getCheckInData,
  ({ selfCheckInStatus }) => selfCheckInStatus
);

export const getStatusTrackerURL = createSelector(
  getSelfCheckInConfigData,
  getLocaleCode,
  ({ statusTrackerURL }, dealerLocale) => {
    const locale = dealerLocale ? `?locale=${dealerLocale}` : '';
    return statusTrackerURL ? 'https://' + statusTrackerURL + locale : '';
  }
);

export const getAdditionalServices = createSelector(
  getSelfCheckInConfigData,
  ({ additionalServices }) => additionalServices
);

export const getAdditionalServicesNotes = createSelector(
  getSelfCheckInConfigData,
  ({ additionalServicesNotes }) => additionalServicesNotes
);

export const getSciIsNavigating = createSelector(
  getSelfCheckInConfigData,
  ({ isNavigating }) => isNavigating
);

export const getSelfCheckInFlow = createSelector(
  getSelfCheckInConfigData,
  ({ selfCheckInFlow }) => selfCheckInFlow
);

export const getIsDealerOpenNow = createSelector(
  getSelfCheckInConfigData,
  ({ isDealerOpenNow }) => isDealerOpenNow
);

export const getInitialLoadingComplete = createSelector(
  getSelfCheckInConfigData,
  ({ initialLoadingComplete }) => initialLoadingComplete
);



// WEBPACK FOOTER //
// ./src/store/reducers/selfCheckIn/selectors.js